<div class="grid-container">
    <div class="params-menu">
        <app-params-menu></app-params-menu>
    </div>
    <div class="params-main-content">
        <router-outlet></router-outlet>
    </div>
</div>
